/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Footer_ProductInputs */

const en_platform_footer_product = /** @type {(inputs: Platform_Footer_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product`)
};

const pl_platform_footer_product = /** @type {(inputs: Platform_Footer_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkt`)
};

/**
* | output |
* | --- |
* | "Product" |
*
* @param {Platform_Footer_ProductInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_footer_product = /** @type {((inputs?: Platform_Footer_ProductInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Footer_ProductInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_footer_product(inputs)
	return en_platform_footer_product(inputs)
});